// Libraries
import styled from "styled-components";
import {
  primary,
  textDefault,
  primaryLight,
  secondary,
  neutral800,
} from "../../assets/colorPallet";

export const BVAButtonContainer = styled.div`
  width: ${(props) =>
    props.fluid ? "100%" : props.shape === "circle" ? "48px" : null};
  height: ${(props) =>
    props.shape === "circle" ? "48px" : props.height ? props.height : null};
  cursor: ${(props) => (props.disabled ? "not-allowed" : null)};
  pointer-events: ${(props) => (props.disabled ? "none" : "all")};
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};

  button {
    box-shadow: ${(props) => (props.shadow ? "1px 1px 8px #3333333b" : null)};
    font-family: "Poppins", sans-serif !important;
  }

  #styled-button {
    background-color: ${(props) => {
      if (props.kind === "primary-selected") return "#00E0CA";
      if (props.kind === "danger") return "#BB2124";
      if (props.kind === "primary") return primary;
      if (props.kind === "primary-light") return primaryLight;
      if (props.kind === "secondary") return secondary;
      if (
        props.kind === "primary-outlined" ||
        props.kind === "secondary-outlined" ||
        props.kind === "primary-light-outlined" ||
        props.kind === "primary-outlined__white" ||
        (props.kind === "dark-outlined" && !props.active)
      ) {
        return "transparent";
      }
      if (props.kind === "dark-outlined--solid") {
        return "white";
      }
      if (props.kind === "white-solid") {
        return "white";
      }

      if (props.kind === "primary-outlined--solid" && !props.active) {
        return "white";
      }
      if (
        (props.kind === "primary-outlined" ||
          props.kind === "primary-outlined--solid") &&
        props.active
      ) {
        return primary;
      }
      if (props.kind === "secondary-outlined" && props.active) {
        return secondary;
      }
      if (props.kind === "primary-light-outlined" && props.active) {
        return primaryLight;
      }
      if (props.kind === "dark-active") {
        return "#ECEFF1";
      }
    }};
    border-radius: ${(props) => {
      if (props.shape === "rounded") return "30px";
      if (props.shape === "circle") return "50%";
      return "8px";
    }};
    color: ${(props) => {
      if (props.kind === "primary") return "white";
      if (props.kind === "white-solid") return neutral800;
      if (props.kind === "primary-selected") return "#003D37 !important";
      if (props.kind === "secondary") return "white";
      if (
        (props.kind === "primary-outlined" ||
          props.kind === "primary-outlined--solid") &&
        !props.active
      )
        return primary;
      if (props.kind === "primary-light-outlined" && !props.active)
        return primaryLight;
      if (props.kind === "secondary-outlined" && !props.active)
        return secondary;
      if (props.kind === "primary-outlined" && props.active) return "white";
      if (props.kind === "secondary-outlined" && props.active) return "white";
      if (props.kind === "primary-outlined__white") return "white";
      if (props.kind === "primary-transparent") return primary;
      if (
        props.kind === "transparent" ||
        (props.kind === "dark-outlined" && props.shape !== "circle")
      )
        return textDefault;
      if (
        props.kind === "dark-outlined" &&
        props.shape === "circle" &&
        !props.active
      )
        return textDefault;
      if (
        props.kind === "dark-outlined" &&
        props.shape === "circle" &&
        props.active
      )
        return "white";
      if (props.kind === "dark-outlined--solid") return textDefault;
      if (props.kind === "dark-active") return "#000A12";
      return "white";
    }};
    border: ${(props) => {
      if (
        props.kind === "primary-outlined" ||
        props.kind === "primary-outlined--solid"
      )
        return `2px solid ${primary}`;
      if (props.kind === "primary-selected") return "2px solid #009688";
      if (props.kind === "primary-light-outlined")
        return `2px solid ${primaryLight}`;
      if (props.kind === "secondary-outlined") return `2px solid ${secondary}`;
      if (props.kind === "outlined") return "2px solid white";
      if (props.kind === "primary-outlined__white") return "2px solid white";
      if (props.kind === "dark-outlined" && props.shape !== "circle")
        return `1px solid ${textDefault}`;
      if (props.flat || props.kind === "primary-transparent") return "none";
      if (
        (props.kind === "dark-outlined" && props.shape === "circle") ||
        props.kind === "dark-outlined--solid"
      )
        return `1px solid ${textDefault}`;
      if (props.kind === "dark-active") return `2px solid #000A12`;
      return null;
    }};
    text-transform: ${(props) => {
      if (props.uppercase) {
        return "uppercase";
      }

      return "unset";
    }};

    height: ${(props) => {
      if (props.slimHeight && !props.height) {
        return "34px";
      }

      if (!props.slimHeight && !props.height && props.shape !== "circle") {
        return "60px";
      }

      if (props.shape === "circle") {
        return "48px";
      }

      if (props.height) {
        return props.height;
      }
    }};
    padding: ${(props) =>
      props.shape === "circle"
        ? "0"
        : props.shape === "rounded"
        ? "8px 16px"
        : "0 24px"};
    font-weight: ${(props) =>
      props.flat || props.semiBold ? "500" : props.light ? "400" : "600"};
    font-size: ${(props) => {
      if (props.large) return "16px";
      return "14px";
    }};
    width: ${(props) =>
      props.fluid ? "100%" : props.shape === "circle" ? "48px" : null};
    line-height: 18px;
    font-family: "Poppins";
  }

  span div div label {
    color: ${(props) => (props.kind === "primary-selected" ? "#003D37" : null)};
  }

  .MuiButton-root {
    min-width: ${(props) => (props.shape === "circle" ? "48px" : null)};
  }

  .MuiIconButton-root {
    background-color: ${(props) => {
      switch (props.kind) {
        case "white":
          return "white";
        default:
          break;
      }
    }};
    transition: opacity 0.2s ease-in-out;

    &:hover {
      background-color: ${(props) => {
        switch (props.kind) {
          case "white":
            return "white";
          default:
            break;
        }
      }};
    }
  }

  svg {
    fill: ${(props) => (props.iconColor ? props.iconColor : textDefault)};
    width: ${(props) => (props.iconSize ? props.iconSize : "20px")};
    height: ${(props) => (props.iconSize ? props.iconSize : "20px")};

    path {
      fill: ${(props) => (props.applyFillOnSVGPath ? props.iconColor : null)};
    }
  }
`;
